import type { FormState } from "react-hook-form";
import { useEffect } from "react";

// account for header height and question index
const HEADER_HEIGHT = 64;
const SCROLL_OFFSET = HEADER_HEIGHT + 25;

type ScrollToFieldErrorProps = {
  formState: FormState<any>;
};

export function ScrollToErrorHandler({ formState }: ScrollToFieldErrorProps): null {
  const { errors } = formState;

  useEffect(() => {
    const firstErrorKey = Object.keys(errors)[0];

    if (!firstErrorKey) return;

    const errorField = document.querySelector(`[data-field-name="${firstErrorKey}"]`);

    if (!errorField) return;

    (errorField as HTMLElement).style.scrollMarginTop = `${SCROLL_OFFSET}px`;
    errorField.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, [formState]);

  return null;
}
